import lettersTypeEnumList from '../../../../components/AgGrid/enumLists/lettersTypeEnumList'

const lettersTypeValueGetter = (props) => {
  const { value } = props
  return lettersTypeEnumList(value)
}

export default lettersTypeValueGetter
